var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bank_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0245A3",
    d: "M0 30.666h32V32H0zm32-20.605V12h-4v13.333h2.667v1.333H1.333v-1.333H4V12H0v-1.94c0-1.526.848-2.896 2.212-3.578L14.367.41a3.43 3.43 0 0 1 3.286.01l12.135 6.06A3.98 3.98 0 0 1 32 10.06M5.333 25.333h5.334V12H5.333zM20 12h-8v13.333h8zm6.667 0h-5.334v13.333h5.334zm4-1.94a2.65 2.65 0 0 0-1.475-2.386l-12.156-6.07a2.12 2.12 0 0 0-2.052-.011L2.808 7.674a2.65 2.65 0 0 0-1.475 2.387v.605h29.334z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bank_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgBank;